export const SET_IS_SSR = 'SET_IS_SSR'

/**
 * Reducer section
 */
const initialState = {}

// FlowType
type Action = {
  type: string,
  payload: {},
}

export function reducer(state = initialState, action: Action) {
  switch (action.type) {
    default:
      return state
  }
}
